<template>
  <section>
    <top-menu/>
    <section>
      <div class="page-content">
        <div class="container-fluid">
          <div class="col-xs-12 col-sm-12 col-md-12 table-box">
            <div class="table-box--header">
              <span class="table-box--header-title">
                <ion-icon name="document-text-outline"></ion-icon>
                Extrato de movimentação da PMA
              </span> <span class="table-box--header-subtitle">
                Gerencie as solicitações de cartões efetuados pelas empresas
              </span>
              <div class="row">
                <div class="table-box--form">
                  <datapickerGlobal col-bootstrap="col-md-3" labelDynamic="Data Inicial / Final" rangeDaysInit="29"
                                    rangeDaysMax="29" haveRangeDaysMax="true" variableName="date"/>
                  <div class="form-button col-md-2">
                    <button @click="getContentBenefitsPma(true)">Pesquisar</button>
                  </div>
                </div>
              </div>
            </div>
            <full-loading v-if="loadingPma"/>
            <div v-else class="table-box--content">
              <table class="content-table">
                <thead>
                <tr>
                  <th>
                    Nome da empresa
                    <ion-icon id="companyName" v-on:click="orderSort('companyName')"
                              name="caret-down-outline"></ion-icon>
                  </th>
                  <th>
                    Tipo
                    <ion-icon id="type" v-on:click="orderSort('type')"
                              name="caret-down-outline"></ion-icon>
                  </th>
                  <th>
                    Saldo autorizado
                    <ion-icon id="amountAuthorized" v-on:click="orderSort('amountAuthorized')"
                              name="caret-down-outline"></ion-icon>
                  </th>
                  <th>
                    Saldo anterior
                    <ion-icon id="balanceBefore" v-on:click="orderSort('balanceBefore')"
                              name="caret-down-outline"></ion-icon>
                  </th>
                  <th>
                    Saldo depois
                    <ion-icon id="balanceAfter" v-on:click="orderSort('balanceAfter')"
                              name="caret-down-outline"></ion-icon>
                  </th>
                  <th>
                    Solicitado
                    <ion-icon id="createdAt" v-on:click="orderSort('createdAt')"
                              name="caret-down-outline"></ion-icon>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(value, index) in contentBenefitsPma" :key="index">
                  <td class="content-table--company-name">
                    <a v-if="value.id !== ''" :href="'/detalhes-da-empresa/' + value.id + '/' + value.contextCode"
                       target="_blank">
                      <span>{{ value.name }}</span>
                    </a>
                    <span v-else>{{ value.name }}</span>
                  </td>
                  <td class="content-table--value">
                    {{ value.type }}
                  </td>
                  <td class="content-table--value">
                    {{ value.amountAuthorized }}
                  </td>
                  <td class="content-table--value">
                    {{ value.amountBefore }}
                  </td>
                  <td class="content-table--value">
                    {{ value.balanceAfter }}
                  </td>
                  <td class="content-table--value">
                    {{ value.createdAt }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import datapickerGlobal from "../../components/inputs/datapickerGlobal.vue";
import {REQUEST_SERVICE, UTIL_SERVICE} from "../../../../requestConfig";
import {PMA_EXTRACT_BENEFITS} from "../../../../urlConfig";
import swal from "sweetalert";
import moment from "moment";

export default {
  name: "benefits-pma-extract",
  components: {
    topMenu,
    fullLoading,
    datapickerGlobal
  },
  data() {
    return {
      loadingPma: false,
      contentBenefitsPma: '',
    };
  },
  methods: {
    getContentBenefitsPma(search) {
      this.loadingPma = true;

      let url = PMA_EXTRACT_BENEFITS;

      if (search) {
        url += "?init=" + this.$route.params.dateInit;
        url += "&end=" + this.$route.params.dateEnd;
      } else {
        const date = new Date();
        const init = moment(date).subtract(29, 'days').format('YYYY-MM-DD')
        const end = moment(date).format('YYYY-MM-DD')

        url += "?init=" + init;
        url += "&end=" + end;
      }

      REQUEST_SERVICE.get(url)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CARDS_BENEFITS:", response.data);

          this.contentBenefitsPma = response.data;
          this.loadingPma = false;
        })
        .catch((reason) => {
          this.loadingPma = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    orderSort(value) {
      $('#updatedAt').css('transform', 'rotate(0deg)');
      $('#type').css('transform', 'rotate(0deg)');
      $('#amountAuthorized').css('transform', 'rotate(0deg)');
      $('#balanceBefore').css('transform', 'rotate(0deg)');
      $('#balanceAfter').css('transform', 'rotate(0deg)');
      $('#createdAt').css('transform', 'rotate(0deg)');

      this.contentBenefitsPma = this.contentBenefitsPma.sort(function (a, b) {
        let valueA = a[value];
        let valueB = b[value];
        if (typeof valueA === 'string') {
          valueA = valueA.toLowerCase().trim();
        }

        if (typeof valueB === 'string') {
          valueB = valueB.toLowerCase().trim();
        }

        if (valueA > valueB) {
          return 1;
        }
        if (valueA < valueB) {
          return -1;
        }
        return 0;
      });

      if (this[value + 'Order'] === true) {
        this.contentBenefitsPma.reverse();
        $('#' + value).css('transform', 'rotate(0deg)');
      } else {
        $('#' + value).css('transform', 'rotate(180deg)');
      }

      this[value + 'Order'] = !this[value + 'Order']
    },
  },
  beforeMount() {
    this.getContentBenefitsPma();
  }
}
</script>

<style lang="scss" scoped>
.container-fluid {
  .table-box {
    padding: 20px 30px;
    background: var(--classic-white);
    border-radius: 10px !important;

    .table-box--header {
      .table-box--header-title {
        display: flex;
        align-items: center;

        font-size: 18px;
        font-weight: 700;
        color: var(--classic-black);

        ion-icon {
          margin-right: 5px;
          font-size: 23px;
          color: var(--dark-gray);
        }
      }

      .table-box--header-subtitle {
        font-size: 14px;
        font-weight: 400;
        color: var(--dark-gray);
      }

      .row {
        margin: 0;
      }

      .table-box--form {
        display: flex;
        margin-top: 25px;

        .form-text-1 {
          display: flex;
          flex-direction: column;
          padding: 0;
          margin-right: 15px;

          label {
            font-size: 14px;
            font-weight: 400;
            color: var(--border-gray);
          }

          .form-text-1-input {
            display: flex;
            position: relative;

            ion-icon {
              position: absolute;
              right: 10px;
              top: 10px;
              font-size: 16px;
              color: var(--dark-gray);
            }

            input {
              width: 100%;
              background: #EEF2F7;
              border-radius: 4px !important;
              padding: 6px 12px;
              border: 1px solid #EEF2F7;
              transition: .2s;

              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);

              &::placeholder {
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
              }

              &:hover {
                transition: .2s;
                border: 1px solid #cacaca;
              }

              &:focus-visible {
                outline: none;
                transition: .2s;
                border: 1px solid #cacaca;

                &::placeholder {
                  transition: .1s;
                  color: #EEF2F7;
                }
              }
            }
          }
        }

        .form-text-2 {
          display: flex;
          flex-direction: column;
          padding: 0;
          margin-right: 15px;
          margin-left: 15px;

          label {
            font-size: 14px;
            font-weight: 400;
            color: var(--border-gray);
          }

          .form-text-2-input {
            display: flex;
            position: relative;

            ion-icon {
              position: absolute;
              right: 10px;
              top: 10px;
              font-size: 16px;
              color: var(--dark-gray);
            }

            input {
              width: 100%;
              background: #EEF2F7;
              border-radius: 4px !important;
              padding: 6px 12px;
              border: 1px solid #EEF2F7;
              transition: .2s;

              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);

              &::placeholder {
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
              }

              &:hover {
                transition: .2s;
                border: 1px solid #cacaca;
              }

              &:focus-visible {
                outline: none;
                transition: .2s;
                border: 1px solid #cacaca;

                &::placeholder {
                  transition: .1s;
                  color: #EEF2F7;
                }
              }
            }
          }
        }

        .form-select {
          display: flex;
          flex-direction: column;
          padding: 0;
          margin-right: 15px;
          margin-left: 15px;

          label {
            font-size: 14px;
            font-weight: 400;
            color: var(--border-gray);
          }

          .form-select-input {
            position: relative;

            ion-icon {
              position: absolute;
              right: 10px;
              top: 11px;
              font-size: 16px;
              color: var(--dark-gray);
              cursor: pointer;
              pointer-events: none;


            }

            select {
              width: 100%;
              background: #EEF2F7;
              border-radius: 4px !important;
              padding: 6px 12px;
              border: 1px solid #EEF2F7;
              transition: .2s;
              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);
              cursor: pointer;

              -webkit-appearance: none;
              -moz-appearance: none;
              appearance: none;

              &::placeholder {
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
              }

              &:hover {
                transition: .2s;
                border: 1px solid #cacaca;
              }

              &:focus-visible {
                outline: none;
                transition: .2s;
                border: 1px solid #cacaca;

                &::placeholder {
                  transition: .1s;
                  color: #EEF2F7;
                }
              }
            }
          }
        }

        .form-button {
          padding-right: 0;

          button {
            width: 100%;
            height: 59%;
            margin-top: 25.5px;
            background: #2F23D6;
            color: #ffffff;
            border-radius: 4px !important;
            border: none;

            &:hover {
              background: #20179e;
            }
          }
        }
      }
    }

    .table-box--content {
      margin-top: 50px;

      .content-table {
        width: 99%;
        max-width: 99%;
        margin-bottom: 20px;

        thead {
          font-size: 14px;
          color: var(--high-gray);
          line-height: 220%;
          padding-bottom: 5px;
          border-bottom: 1px solid var(--classic-gray);

          tr {
            th {
              font-weight: 500 !important;

              ion-icon {
                width: 13px;
                height: 13px;
                transition: .3s;
                cursor: pointer;
              }
            }
          }
        }

        tbody {
          tr {
            border-bottom: 1px solid var(--classic-gray);

            .content-table--company-name {
              width: 28%;
              color: var(--dark-gray);
              padding: 20px 0;

              a {
                display: list-item;
                width: 140px;
                white-space: nowrap;
                overflow: hidden !important;
                text-overflow: ellipsis;

                font-size: 14px;
                font-weight: 500;
                color: var(--high-blue);
                align-items: center;

                ion-icon {
                  font-size: 14px;
                  margin-right: 4px;
                }
              }
            }

            .content-table--status {
              span {
                border-radius: 4px !important;
                font-size: 12px;
                font-weight: 500;
                padding: 4px 16px;
              }

              .done {
                color: var(--classic-white);
                background: var(--dark-gray);
                padding: 4px 16px;
              }

              .draw {
                color: var(--dark-gray);
                background: var(--drop-shadow-blue);
                padding: 4px 24px;
              }

              .waiting {
                color: var(--dark-gray);
                background: var(--light-yellow);
                padding: 4px 16px;
              }

              .paid {
                background: var(--light-green);
                color: var(--classic-white);
                padding: 4px 38.5px;
              }

              .canceled {
                background: var(--classic-gray);
                color: var(--border-gray);
                padding: 4px 23.5px;
              }

              .pending {
                color: var(--dark-gray);
                background: var(--light-yellow);
                padding: 4px 26px;
              }

              .in-progress {
                color: var(--classic-white);
                background: var(--high-blue);
                padding: 4px 13.5px;
              }

              .concluded {
                background: var(--light-green);
                color: var(--classic-white);
                padding: 4px 25px;
              }

              .none {
                background: var(--dark-gray);
                color: var(--classic-white);
                padding: 4px 28.7px;
              }
            }

            .content-table--value {
              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);
            }

            .content-table--created {
              display: flex;
              flex-direction: column;
              margin-top: 11px;

              font-size: 14px;
              font-weight: 400;
              color: var(--dark-gray);

              span {
                font-size: 12px;
                font-weight: 400;
                color: var(--high-gray);
              }
            }

            .content-table--actions {
              .buttons-actions {
                display: flex;
                flex-direction: row;

                button {
                  display: flex;
                  justify-content: center;
                  align-items: center;

                  background: var(--background-gray);
                  width: 32px;
                  height: 32px;
                  padding: 0;
                  border: none;
                  border-radius: 4px !important;
                  transition: 0.2s;

                  ion-icon {
                    color: var(--dark-gray);
                    font-size: 22px;
                    transition: 0.2s;
                    pointer-events: none;
                  }

                  &:hover {
                    background: var(--high-blue);

                    ion-icon {
                      color: var(--classic-white);
                    }
                  }
                }

                .confirm-payment {
                  display: flex;
                  justify-content: center;
                  align-items: center;

                  background: var(--background-gray);
                  width: 32px;
                  height: 32px;
                  padding: 0;
                  border: none;
                  border-radius: 4px !important;
                  transition: 0.2s;
                  margin-left: 10px;

                  ion-icon {
                    color: var(--dark-gray);
                    font-size: 22px;
                    transition: 0.2s;
                    pointer-events: none;
                  }

                  &:hover {
                    background: var(--light-green);

                    ion-icon {
                      color: var(--classic-white);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.loader-page-content {
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/benefits/benefits-pma-extract.vue